import { FormControlLabel, FormHelperText, Stack, Switch, Typography } from '@mui/material';
import { useField } from 'formik';
import React from 'react';

// Formik-bound switch with label + optional helper text.  Layout:
// label on the left, switch on the right (matches the theme-new
// settings idiom).  Pass `disableDivider` when used inside a host
// row that draws its own bottom border (e.g. the alarm subscription
// row) — otherwise two adjacent dividers stack visibly.  Pass
// `hideLabel` when the field is hosted inside a SettingsFieldRow
// (or any other parent already rendering the label) so this
// component renders only the Switch control without its own row
// chrome.
export default function SettingsSwitchField({
  name,
  label,
  helperText,
  disabled,
  disableDivider = false,
  hideLabel = false,
}) {
  const [field, , helpers] = useField(name);
  if (hideLabel) {
    return (
      <Switch checked={Boolean(field.value)} onChange={(_, checked) => helpers.setValue(checked)} disabled={disabled} />
    );
  }
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        py: 1,
        ...(disableDivider ? {} : { borderBottom: 1, borderColor: 'divider' }),
      }}
    >
      <Stack spacing={0.25} sx={{ flexGrow: 1 }}>
        <Typography variant="body1">{label}</Typography>
        {helperText ? <FormHelperText sx={{ m: 0 }}>{helperText}</FormHelperText> : null}
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={Boolean(field.value)}
            onChange={(_, checked) => helpers.setValue(checked)}
            disabled={disabled}
          />
        }
        label=""
        sx={{ m: 0 }}
      />
    </Stack>
  );
}
